import { CompRef } from '@wix/document-services-types';
import { HostAPIBase } from './HostAPIBase';
import {
  Breakpoint,
  PLATFORM_BREAKPOINT_RANGES,
} from '@wix/editor-platform-host-integration-apis';
import type { EditorPointer } from '@wix/editor-document-logic-api';

export class HostAPIEditorX extends HostAPIBase {
  breakpoints = {
    get: (compRef: CompRef) => {
      return this.platformApiMethods.editor.breakpoints.get(compRef);
    },
  };

  stage = {
    getPointerWithCurrentVariants: (editorPointer: EditorPointer) => {
      return this.platformApiMethods.editor.stage?.getPointerWithCurrentVariants(
        editorPointer,
      );
    },
    getBreakpointFromPointer: (editorPointer: EditorPointer) => {
      return this.platformApiMethods.editor.stage?.getBreakpointFromPointer(
        editorPointer,
        PLATFORM_BREAKPOINT_RANGES,
      );
    },
    getPointerWithBreakpointVariant: (
      editorPointer: EditorPointer,
      breakpoint: Breakpoint,
    ) => {
      const breakpointRange = PLATFORM_BREAKPOINT_RANGES.find(
        (range) => range.size === breakpoint,
      );
      if (!breakpointRange) {
        throw new Error(`Breakpoint ${breakpoint} not found`);
      }

      return this.platformApiMethods.editor.stage?.getPointerWithBreakpointVariant(
        editorPointer,
        breakpointRange,
      );
    },
  };
}
